/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable } from '@angular/core';

/**
 * Provides the EmotionApiConfiguration configuration object with a given root URL.
 */
export function provideEmotionApiConfiguration(rootUrl: string) {
  var config = new EmotionApiConfiguration();
  config.rootUrl = rootUrl;
  return {
    provide: EmotionApiConfiguration,
    useValue: config
  };
}

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class EmotionApiConfiguration {
  rootUrl: string = '';
}

/**
 * Parameters for `EmotionModule.forRoot()`
 */
export interface EmotionApiConfigurationParams {
  rootUrl?: string;
}
